import React from "react";
import { useSyncExternalStore } from "react";
import { modalStore } from "./AlertManager";
import Alert from "./Alert";

const AlertProvider = () => {
  const manager = modalStore;
  const value = useSyncExternalStore(
    manager.subscribe, // 상태 변경 감지 (구독)
    manager.getSnapshot, // 현재 상태 가져오기
  );

  return (
    <section>
      {value.map((modal) => (
        <Alert
          key={modal.id}
          title={modal.title}
          content={modal.content}
          onConfirm={modal.onConfirm}
        />
      ))}
    </section>
  );
};

export default AlertProvider;
